import { MapPin, Clock, Phone, Mail } from "lucide-react";
import { BRAND } from "@/lib/brand";

export const Location = () => {
  return (
    <section
      id="location"
      data-testid="location-section"
      className="relative bg-[#0a0a0a] py-24 md:py-32 px-6 md:px-12 border-t border-white/5"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <span className="h-px w-12 bg-yellow-500" />
          <span className="text-yellow-500 text-xs uppercase tracking-[0.4em]">
            05 — Nous trouver
          </span>
        </div>
        <h2 className="font-display text-white text-5xl md:text-6xl leading-[0.95] mb-12 md:mb-16">
          L'atelier vous<br />
          <span className="text-stroke-yellow">attend.</span>
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* Map */}
          <div className="lg:col-span-8 relative border border-white/10 overflow-hidden min-h-[450px]">
            <iframe
              title="LAD Performance - 56 rue du Stade, 66690 Saint-André"
              src={BRAND.mapEmbed}
              width="100%"
              height="100%"
              style={{ border: 0, filter: "grayscale(0.6) contrast(1.05) invert(0.92)" }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="absolute inset-0 w-full h-full"
              data-testid="map-embed"
            />
          </div>

          {/* Info cards */}
          <div className="lg:col-span-4 space-y-4">
            <InfoCard icon={MapPin} title="Adresse">
              {BRAND.address}
            </InfoCard>
            <InfoCard icon={Phone} title="Téléphone">
              <a
                href={`tel:${BRAND.phoneRaw}`}
                className="hover:text-yellow-500 transition-colors"
              >
                {BRAND.phone}
              </a>
            </InfoCard>
            <InfoCard icon={Mail} title="Email">
              <a
                href={`mailto:${BRAND.email}`}
                className="hover:text-yellow-500 transition-colors break-all"
              >
                {BRAND.email}
              </a>
            </InfoCard>
            <InfoCard icon={Clock} title="Horaires">
              <div className="space-y-1">
                {BRAND.hours.map((h) => (
                  <div key={h.day} className="flex justify-between text-sm gap-4">
                    <span className="text-zinc-400">{h.day}</span>
                    <span className="text-white">{h.time}</span>
                  </div>
                ))}
              </div>
            </InfoCard>
          </div>
        </div>
      </div>
    </section>
  );
};

const InfoCard = ({ icon: Icon, title, children }) => (
  <div className="bg-black/50 border border-white/10 p-5 hover:border-yellow-500/50 transition-colors">
    <div className="flex items-center gap-3 mb-2">
      <Icon className="w-4 h-4 text-yellow-500" />
      <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500">{title}</div>
    </div>
    <div className="text-white text-base leading-relaxed">{children}</div>
  </div>
);
